<mat-sidenav-container>
  @if (isLoggedIn()) {
    <mat-sidenav
      #sidenav
      class="mat-elevation-z4"
      [disableClose]="!mobileNav()"
      [opened]="navOpen()"
      (closed)="closeSideNav()"
      [mode]="mobileNav() === true ? 'over' : 'side'"
      [class.collapsed]="isCollapsed()"
    >
      <mat-toolbar class="logo-toolbar">
        @if (!isCollapsed()) {
          <img
            class="main-logo"
            routerLink="."
            (click)="reload()"
            src="static/assets/images/glitchtip-logo-v1.svg"
            alt="GlitchTip"
          />
        } @else {
          <img
            class="collapsed-logo"
            routerLink="."
            (click)="reload()"
            src="static/assets/images/glitchtip-logo-collasped.svg"
            alt="GlitchTip"
          />
        }
        <button
          mat-icon-button
          class="collapse-toggle"
          (click)="toggleCollapse()"
        >
          @if (isCollapsed()) {
            <mat-icon>left_panel_open</mat-icon>
          } @else {
            <mat-icon>left_panel_close</mat-icon>
          }
        </button>
      </mat-toolbar>
      @if (contextLoaded() && organizations().length === 0 && canCreateOrg()) {
        <div class="org-create-button-container">
          <a
            matButton="outlined"
            id="create-new-link"
            routerLink="/organizations/new"
            class="org-create-button"
            i18n
            >Create Organization<mat-icon iconPositionEnd>add</mat-icon></a
          >
        </div>
      } @else {
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="org-dropdown-container"
        >
          <mat-select
            #orgSelect
            data-cy="orgSelect"
            [value]="activeOrganizationSlug()"
            formControlName="orgSelectControl"
            (selectionChange)="onOrgSelectChange($event, orgSelect)"
            hideSingleSelectionIndicator
            canSelectNullableOptions
          >
            @for (
              organization of organizations();
              track organization.id;
              let last = $last
            ) {
              <mat-option [value]="organization.slug">
                {{ organization.name }}
              </mat-option>
              @if (last) {
                <mat-divider class="dropdown-divider"></mat-divider>
              }
            }
            @if (canCreateOrg()) {
              <mat-option data-cy="createNewLink" i18n
                >Create organization</mat-option
              >
            } @else {
              <mat-option
                disabled
                matTooltip="Organization creation is currently disabled"
                matTooltipPosition="below"
              >
                Create organization
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <mat-nav-list>
        <mat-divider class="nav-section-divider"></mat-divider>
        <!-- Main nav items -->
        @for (item of visibleNavItems(); track item.route) {
          @if (activeOrganization()) {
            <a
              mat-list-item
              [routerLink]="getRouteWithOrgSlug(item.route)"
              routerLinkActive="mdc-list-item--activated"
              [matTooltip]="item.name"
              [matTooltipDisabled]="!isCollapsed()"
              matTooltipPosition="right"
            >
              <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
              <span class="nav-text">{{ item.name }}</span>
            </a>
          } @else {
            <mat-list-item
              disabled
              [matTooltip]="item.name"
              [matTooltipDisabled]="!isCollapsed()"
              matTooltipPosition="right"
            >
              <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
              <span class="nav-text">{{ item.name }}</span>
            </mat-list-item>
          }
        }

        <mat-divider class="nav-section-divider"></mat-divider>

        <!-- Organization menu item -->
        <div
          routerLinkActive
          [routerLinkActiveOptions]="{
            paths: 'subset',
            queryParams: 'ignored',
            fragment: 'ignored',
            matrixParams: 'ignored',
          }"
          #orgWrapper="routerLinkActive"
        >
          <button
            mat-list-item
            [matMenuTriggerFor]="orgMenu"
            [disabled]="!activeOrganization()"
            [class.active-section]="orgWrapper.isActive"
            matTooltip="Organization"
            [matTooltipDisabled]="!isCollapsed()"
            matTooltipPosition="right"
            i18n-matTooltip
          >
            <mat-icon matListItemIcon>account_tree</mat-icon>
            <span matListItemTitle class="nav-text" i18n>Organization</span>
            <div matListItemMeta>
              <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
            </div>
          </button>
          @for (item of visibleOrgMenuItems(); track item.route) {
            <a
              [routerLink]="getRouteWithOrgSlug(item.route)"
              style="display: none"
            ></a>
          }
        </div>

        <!-- Profile menu item -->
        <div
          routerLinkActive
          [routerLinkActiveOptions]="{
            paths: 'subset',
            queryParams: 'ignored',
            fragment: 'ignored',
            matrixParams: 'ignored',
          }"
          #profileWrapper="routerLinkActive"
        >
          <button
            mat-list-item
            [matMenuTriggerFor]="profileMenu"
            [class.active-section]="profileWrapper.isActive"
            matTooltip="Profile"
            [matTooltipDisabled]="!isCollapsed()"
            matTooltipPosition="right"
            i18n-matTooltip
          >
            <mat-icon matListItemIcon>account_circle</mat-icon>
            <span matListItemTitle class="nav-text" i18n>Profile</span>
            <div matListItemMeta>
              <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
            </div>
          </button>
          @for (item of profileMenuItems; track item.route) {
            <a [routerLink]="item.route" style="display: none"></a>
          }
        </div>
      </mat-nav-list>

      <mat-menu #orgMenu="matMenu" class="nav-menu" xPosition="after">
        @if (activeOrganization()) {
          @for (item of visibleOrgMenuItems(); track item.route) {
            <button
              mat-menu-item
              [routerLink]="getRouteWithOrgSlug(item.route)"
              routerLinkActive="active-menu-item"
              [routerLinkActiveOptions]="{ exact: item.exactRoute ?? false }"
            >
              <mat-icon>{{ item.icon }}</mat-icon>
              <span>{{ item.name }}</span>
            </button>
          }
        }
      </mat-menu>

      <mat-menu #profileMenu="matMenu" class="nav-menu" xPosition="after">
        @for (item of profileMenuItems; track item.route) {
          <button
            mat-menu-item
            [routerLink]="item.route"
            routerLinkActive="active-menu-item"
            [routerLinkActiveOptions]="{ exact: item.exactRoute ?? false }"
          >
            <mat-icon>{{ item.icon }}</mat-icon>
            <span>{{ item.name }}</span>
          </button>
        }
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span i18n>Log Out</span>
        </button>
      </mat-menu>

      @if (paidForGlitchTip() === false) {
        <mat-divider class="support-cta-divider"></mat-divider>
        <div class="support-cta-container">
          <div class="body-text-strong" il8n>Support GlitchTip</div>
          <ul class="support-cta-list body-text">
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://liberapay.com/GlitchTip/donate"
                il8n
                >Donate
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener"
                href="https://app.glitchtip.com/register?utm_medium=website&utm_source=glitchtip&utm_campaign=selfhost_nagware"
                il8n
                >Switch to hosted</a
              >
            </li>
            <li>
              <a
                href="mailto:sales@glitchtip.com?subject=Purchase support inquiry"
                il8n
                >Purchase support</a
              >
            </li>
          </ul>
        </div>
      }
      <div class="caption-text version">
        <a [routerLink]="['/system-info']" routerLinkActive="active-route" i18n
          >GlitchTip {{ version() }}</a
        >
      </div>
    </mat-sidenav>
  }

  <mat-sidenav-content>
    @if (isLoggedIn()) {
      <gt-mobile-nav-toolbar
        [activeOrg]="activeOrganization()"
        (buttonClicked)="toggleSideNav()"
      ></gt-mobile-nav-toolbar>
    }
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
